export default defineNuxtPlugin((nuxtApp) => {
  const apolloClient = nuxtApp.$apollo.defaultClient

  if (apolloClient) {
    apolloClient.cache.policies.addTypePolicies({
      Article: {
        fields: {
          GlobalAttributes: {
            merge(existing, incoming) {
              // Merge the existing and incoming objects
              return { ...existing, ...incoming }
            },
          },
        },
      },
      Employee_Employeefields: {
        merge(existing, incoming) {
          return {
            ...existing,
            ...incoming,
          }
        },
      },
      Department_Departmentfields: {
        merge(existing, incoming) {
          return incoming
        },
      },

      Student_Studentfields: {
        merge(existing, incoming) {
          return {
            ...existing,
            ...incoming,
          }
        },
      },
    })
  }
})
